<template>
    <div class="salesmanzhaoshang">
        <XR-head titleText="我的招商" :rightShow="false" ref="headObj"></XR-head>
        <div class="gd-content">
            <h5> 招商总人数：<div class="canvassTotal" style="color:red; display:inline;">{{totalCount}}</div>人</h5>
            <mu-list v-if="pageData.length>0">
                <mu-list-item v-for="dItem in pageData" :key="dItem.MinnerBm">
                     <div class="mu-item-title">
                         <div class="dd3">
                            <img :src="dItem.HeadPic" alt="">
                        </div>
                        <div class="dd1">
                            <p>{{dItem.UserName}}</p>             
                            <p class="telephone">{{dItem.Mobile}}</p>
                        </div>
                        <div class="dd1 dd2">
                            <p >{{dItem.ShopManagement && dItem.ShopManagement.length>8?dItem.ShopManagement.substr(0,8)+'...':dItem.ShopManagement}}</p>
                            <p class="date">{{dItem.CreateDateName}}</p>            
                        </div>
                    </div>
                </mu-list-item>
                
            </mu-list>
        </div>
        <XR-PageTip ref="XRPageTip"></XR-PageTip>
    </div>
</template>
<script>
export default {
    data(){
        return {
            pageData:[],
            totalCount:0
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(){                  
            const ths = this;
            this.$post("/Salesman/SalesmanServer/GetCanvassShopList")
            .then(function(res) {
                if (res.IsSuccess) {
                    ths.pageData = res.Data.List
                    ths.totalCount = res.Data.Rows
                    
                    ths.$refs.XRPageTip.initTip()
                }else{                    
                    ths.pageData = []
                    ths.totalCount = 0
                    ths.$refs.XRPageTip.ShowEmpty('暂无数据')
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
    }
}
</script>

<style>
        body .salesmanzhaoshang{
            background: #fff;
        }
        .salesmanzhaoshang .gd-content h5
        {
            font-size:12px;
            font-weight:400;
            text-align:center;    
            padding:17px 0;
        }
        .salesmanzhaoshang .gd-content h5 span
        {
            color:#333;
        }
        .salesmanzhaoshang .mmpl-list{
            height: 70px;
            font-size: inherit;
            line-height: inherit;
            padding: 0;
            margin: 0;
            font-family: inherit;
        }
        .salesmanzhaoshang .mmpl-list ul
        {
            padding: .25rem 1rem;
            background: #fff;
            height: 100%;
            list-style-type: none;
        }

        .salesmanzhaoshang .mmpl-list ul li
        {   
          height: 100%;
            padding: 12px 0;
            line-height:18px;
            border-bottom: 1px dotted #ccc;
        }
        .salesmanzhaoshang .mmpl-list ul li.foot
        {   
          border:0px;
        }


        .salesmanzhaoshang .mmpl-list .list-content i.ico_jkklgo
        {
            float: left;
            margin-right: .75rem;
            font-size: 2.5rem;
            line-height: 1;
            color: #002263;
            margin-top:.5rem;
        }
        .salesmanzhaoshang .mmpl-list li
        {
            font-size:12px;
        }
        
        .salesmanzhaoshang .mu-list .list:last-child .mu-item{
          border-bottom: 0;
          border-radius: 50%;
        }
      .salesmanzhaoshang .dd1{
            float:left;
            width: 50%;
            padding-left: 5%;
            text-align:left;
        }
      .salesmanzhaoshang .dd1,.salesmanzhaoshang .dd2 {
        font-size: 12px;
        }
      .salesmanzhaoshang .dd1 .number{
        color: #999;
        }
      .salesmanzhaoshang .mu-list .mu-checkbox{
        float: left;
        width: 10%;
        margin-top: 5px;
      }
      .salesmanzhaoshang .mu-checkbox .mu-checkbox-icon-uncheck, .salesmanzhaoshang .mu-checkbox-icon-checked {
        font-size: 18px;
        margin-top: 3px;   
      }
      .salesmanzhaoshang .dd2 .date {  font-size:12px;color: #999;}
      .salesmanzhaoshang .dd2{
          float:left;
          width:30%;
          text-align:right;
      }
      .salesmanzhaoshang .dd3
        {
            float:left;
            width:10%;
            text-align:center;

        }
        .salesmanzhaoshang .dd3 img{
          width: 35px;
          height: 35px;
          border-radius: 50%;
          object-fit: cover;
        }
</style>




// WEBPACK FOOTER //
// src/pages/salesman/myzhaoshang.vue